import { render, staticRenderFns } from "./serviceRequest.vue?vue&type=template&id=267e04fa&scoped=true&"
import script from "./serviceRequest.vue?vue&type=script&lang=js&"
export * from "./serviceRequest.vue?vue&type=script&lang=js&"
import style0 from "./serviceRequest.vue?vue&type=style&index=0&id=267e04fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267e04fa",
  null
  
)

export default component.exports